import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Slide } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';

const CONSENT_KEY = 'bopis_cookie_consent';

const CookieConsent = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const consent = localStorage.getItem(CONSENT_KEY);
        if (!consent) {
            // Small delay before showing banner for better UX
            const timer = setTimeout(() => {
                setShowBanner(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(CONSENT_KEY, 'accepted');
        setShowBanner(false);
    };

    const handleReject = () => {
        localStorage.setItem(CONSENT_KEY, 'rejected');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <Slide direction="up" in={showBanner} mountOnEnter unmountOnExit>
            <Paper
                elevation={6}
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                    p: 2,
                    borderRadius: '16px 16px 0 0',
                    bgcolor: '#fff',
                    boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
                }}
            >
                <Box
                    sx={{
                        maxWidth: 1200,
                        mx: 'auto',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        gap: 2,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, flex: 1 }}>
                        <CookieIcon sx={{ color: '#f59e0b', fontSize: 28, mt: 0.3 }} />
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                We use cookies
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                                We use cookies to enhance your browsing experience and analyze site traffic.
                                By clicking "Accept All", you consent to our use of cookies.
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            width: { xs: '100%', sm: 'auto' },
                            justifyContent: { xs: 'flex-end', sm: 'flex-start' },
                        }}
                    >
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={handleReject}
                            sx={{
                                borderColor: '#d1d5db',
                                color: '#6b7280',
                                textTransform: 'none',
                                px: 2,
                                '&:hover': {
                                    borderColor: '#9ca3af',
                                    bgcolor: '#f9fafb',
                                },
                            }}
                        >
                            Reject All
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={handleAccept}
                            sx={{
                                bgcolor: '#2563eb',
                                textTransform: 'none',
                                px: 2,
                                '&:hover': {
                                    bgcolor: '#1d4ed8',
                                },
                            }}
                        >
                            Accept All
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Slide>
    );
};

export default CookieConsent;
